<template>
  <div class="page-content">
    <!-- mobile view Searching -->
    <div class="Searching_input_box_mobile_view mb-3 position-relative">
      <!-- v-if="!superadmin()" -->
      <div class="w-100" v-if="this.show">
        <input :disabled="searchDisable" type="text" v-model="input" @keyup.enter="filteredList"
          placeholder="Search..." />
        <!-- <div class="search_detail_list" v-if="this.result.length > 0">
          <div v-for="(item, index) in this.result" :key="index" class="search_detail_list_item"
            @click="searchregionname(item)" style="cursor: pointer">
            <span :id="index" @click="searchregionname(item)">
              {{ stringTOHtml(item, index) }}
            </span>
          </div>
        </div> -->
        <img src="../../public/dashboard-assets/images/M2/Close_icon.png" @click="closemobilesearch" alt=""
          class="close-icon" />
      </div>
    </div>

    <!-- header -->
    <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
      <div class="my-2">
        <h4 class="mb-2 mb-md-0">Token Management</h4>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <!-- Search  web view-->
        <div class="top_heading_CreatePartner_btn position-relative z-index-999">
          <div class="Group_top_three_dot">
            <div class="Searching_input-box">
              <input :disabled="searchDisable" type="text" v-model="input" @keyup.enter="filteredList"
                placeholder="Search..." />
              <!-- <div class="search_detail_list" v-if="this.result.length > 0">
                <div v-for="(item, index) in this.result" :key="index" class="search_detail_list_item"
                  @click="searchregionname(item)" style="cursor: pointer">
                  <span :id="index" @click="searchregionname(item)">
                    {{ stringTOHtml(item, index) }}
                  </span>
                </div>
              </div> -->
              <span class="icon Group_top_three_dot_dropdown" @click="opensearch">
                <img src="../../public/dashboard-assets/images/M2/Icon-Set.png" alt="" class="Searching_search_icon" />
              </span>
              <img src="../../public/dashboard-assets/images/M2/Close_icon.png" @click="closesearch" alt=""
                class="close-icon" />
            </div>
          </div>
        </div>

        <!-- Mobile View Searching Button -->
        <div class="top_heading_CreatePartner_btn position-relative Searching_button_mobileView">
          <!-- v-if="!superadmin()" -->
          <div class="Group_top_three_dot">
            <span class="icon Group_top_three_dot_dropdown" :style="{ display: this.show == true ? 'none' : 'block' }"
              @click="openmobilesearch">
              <img src="../../public/dashboard-assets/images/M2/Icon-Set.png" alt="" class="Searching_search_icon" />
            </span>
          </div>
        </div>
        <!-- Filter -->
        <!-- <div
          class="top_heading_CreatePartner_btn top_heading_CreatePartner_btn-kj d-block mx-2"
        >
          <div class="Group_top_three_dot">
            <div class="dropdown">
              <button
                class="btn p-0 Group_top_three_dot_dropdown position-relative"
                type="button"
                id="filterDropDown"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
                aria-haspopup="true"
                style="line-height: 0.3"
                @click="filterData" 
              >
              
                <img
                  src="../../public/dashboard-assets/images/M2/Filter_icon.png"
                />

                <span
                  class="Noti-alert-kj translate-middle"
                  v-if="this.applyfilter > 0"
                >
                  {{ this.applyfilter }} <span class="visually-hidden"></span>
                </span>
              </button>

              <ul
                class="dropdown-menu dropdown-menu-kj"
                aria-labelledby="filterDropDown"
              >
                <div class="modal-header">
                  <h4
                    class="modal-title text-centerm-auto"
                    id="CreateGroupModalLabel"
                  >
                    Filter
                  </h4>
                  <button
                    type="button"
                    class="btn-close"
                    @click="crossfilter"
                  ></button>
                </div>

                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li class="nav-item w-50" role="presentation">
                <button
                  class="nav-link active"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                  @click="this.filterTab=1"
                >
                  Test
                </button>
              </li>
                  <li class="nav-item w-50" role="presentation">
                  <button
                    class="nav-link active"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    Partner
                    {{
                      this.filters.partners.length > 0
                        ? "(" + this.filters.partners.length + ")"
                        : ""
                    }}
                  </button>
                  </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                  <div
                    class="tab-pane fade show active p-0"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div class="search-bar">
                      <form class="search-form">
                        <input
                          type="text"
                          placeholder="Search"
                          name=""
                          class="form-control bg-white"
                          v-model="searchfilter"
                          @keyup="Filterresult"
                        /><button class="btn">
                          <i class="fas fa-search"></i>
                        </button>
                      </form>
                      <div class="ul-li-checkbox-kj">
                        <ul>
                          <li
                            v-for="item in this.filterPartnerData"
                            :key="item"
                          >
                            <input
                              type="checkbox"
                              name=""
                              id=""
                              :value="item.clientId"
                              @change="addFilter(item.clientId, $event)"
                              :checked="
                                this.filters.partners.includes(item.clientId)
                              "
                            />
                            <span>{{ item.clientName }} </span>
                          </li>
                        </ul>
                        <div class="text-end">
                          <button
                            type="button"
                            class="btn-Apply-kj-color"
                            v-if="this.applyfilter > 0"
                            @click="clearFilters"
                          >
                            Clear Filter
                          </button>
                          <button
                            type="button"
                            class="modail_submit_button"
                            :disabled="!filterDisabledButton()"
                            :class="{
                              active_form_button: this.applyfilter > 0,
                            }"
                            @click="applyFilters()"
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <div class="card p-0 border-radius-100 ms-3 token-view-d-none-kj">
          <div class="card-body px-3 py-3">
            <div class="d-flex justify-content-between align-items-center">
              <div
                class="d-flex token_secand_header_company align-items-center"
              >
                <div class="PartnerTeamMembersProfile-area-kj">
                  <div class="PartnerTeamMembersProfile-kj name-logo-1">
                    {{ regionAllocationList.company?.charAt(0) }}
                  </div>
                </div>
                 <img src="../../public/dashboard-assets/images/M2/logo.png" alt="" /> 
                <div class="mx-3">
                  <h6>Test Tokens:</h6>
                  <p class="font-size-12">
                    <span
                      class="color_blue"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Remaining Token"
                      >{{ regionAllocationList.remainingToken }}</span
                    >/<span
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Remaining Token"
                      >{{ regionAllocationList.allocatedToken }}</span
                    >
                  </p>
                </div>
              </div>
              <div
                class="d-flex justify-content-between align-items-center token_secand_header_section"
                v-if="!superadmin()"
              >
                <div class="top_heading_CreatePartner_btn d-block mx-2">
                  <button
                    type="button"
                    class="btn btn-primary btn-icon-text"
                    data-bs-toggle="modal"
                    data-bs-target="#RequestTokenModal"
                  >
                    <i class="fa-solid fa-plus me-2"></i> Request Token
                  </button>
                </div>
              </div> 
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="row">
      <div class="col-xl-8 col-lg-8 partners_top_menu_section_hp">
        <div class="row">
          <div class="col-3">
            <router-link :to="{ name: 'TestManagement' }" class="w-100 btn">
              Overview
            </router-link>
          </div>
          <div class="col-3">
            <router-link :to="{ name: 'TokenmanagementViewTest' }" class="w-100 btn">
              View Test
            </router-link>
          </div>
          <div class="col-3">
            <router-link :to="{ name: 'TokenmanagementViewRegion' }"
              class="w-100 btn active btn-outline-primary btn-icon-text">
              View Group <span>({{ viewdataTotalcount }})</span>
            </router-link>
          </div>
          <div class="col-3" v-if="superadmin()" >
            <router-link :to="{ name: 'TokenLogs' }" class="w-100 btn">
              View Logs
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- data  -->
    <div class="token_secand_header_section token-view-web-d-none-kj mt-3">
      <div class="card p-0">
        <div class="card-body px-3 py-3">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex token_secand_header_company align-items-center">
              <img
                src="data:image/png;base64,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"
                alt="" />
              <div class="mx-2">
                <h6>Test Tokens:</h6>
                <p class="font-size-12">
                  <span class="color_blue">{{
                    regionAllocationList.allocatedToken
                    }}</span>/{{ regionAllocationList.remainingToken }}
                </p>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="top_heading_CreatePartner_btn d-none d-md-block">
                <div class="Group_top_three_dot">
                  <div class="dropdown">
                    <button class="btn p-0 Group_top_three_dot_dropdown" type="button" id="dropdownMenuButton"
                      data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="line-height: 0.3">
                      <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIXSURBVHgB3VU7TwJBEF6eMaHRzhJ/AMnxbIn/gNLOI+FhhyUdR2eJBYHjEY+STksrodMCWP8BdthRGgjgN+TuvCwHeEQLnWSze7uz883szDfH2F8X165DWZaPfT7fpdvtlpbLZXB9weXimPhisei12+03dihAJpMpwdg1xvFqtZoChAwzAEnGHkal1WqVmRMA8trv9z9hSYY0jE69Xu9ZdbLZrATAAgBkimY2m51rmja1A/CKG2QcF4MwLKuq2rG71Gw2KZp0Pp/niEjRHQrb6XqsH7lcroTpAqMIIyrbI4PB4CUWi02wvAqHw2w4HPZFHfOJ8DRBJHSE0O/heZo5EERyh0hS8/n8THwqt7FAmElKHhRvmUOBU5SrdcVtnFnWElWG/r6OpFar9fVKk7YCwAM6dGzcNIQyNrhiC/BbYgUYY0jsQNEJyLcCQIFTokCiJHMoRDy6y2ye2ARAiXUoUVjKzLkQq6eoop54YBKNc/4B0hxR/4lGo2OQ6JV9Q+B9AXeKALgBfx7E841eBDaPqFVgqaBkd3ICulT3ml7eJ3Y6HnEjFAp1vV5vinpRJBIJxuNxiuZd8DqJKBXoKPgcYz7d2ypsvCvBM7Nds68Emu0ac6XRaJT1HqZQ4xPbt2cbALzuJxKJLgxxkGhCXmIQIZ+xpwUCgXS1Wn00dBERnSliJDv/aE7FiIQiN/L3o0ym5yIA9q/kE1RW/0GByI6AAAAAAElFTkSuQmCC" />
                    </button>
                  </div>
                </div>
              </div>
              <!-- <button
                type="button"
                class="btn btn-primary btn-icon-text request_tokens_button_mobielView"
                data-bs-toggle="modal"
                data-bs-target="#RequestTokenModal"
              >
                <i class="fa-solid fa-plus me-2"></i> Request Token
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- empty section -->
    <section class="Partner_empty_main_section_hp mt-4" v-if="groupData.length == 0">
      <div class="row">
        <div class="Partner_empty_img_hp m-auto text-center">
          <img src="../../public/dashboard-assets/images/M2/empty_record.png" alt="" />
          <h2>No Record Found</h2>
        </div>
        <!-- <div class="Partner_empty_content_hp m-auto text-center">
      <div class="mb-4">
        <h2>Woohoo, No Members!</h2>
        <p class="text-muted mt-2">
          Your list of partners will appear here
        </p>
      </div>
    </div> -->
      </div>
    </section>
    <section class="Partner_empty_main_section_kj mt-3" v-else>
      <div class="row">
        <div class="col-md-6 col-lg-4 col-xl-3 mb-3 stretch-card" v-for="item in groupData" :key="item">
          <div class="card p-0">
            <!-- <router-link :to="{ name: '' }"> -->
            <div class="card-body p-3">
              <div class="Partner_management_top-kj mb-2">

                <h5 class="text-dark" v-if="item.regionName.length > 40">
                  {{
                    item.regionName.substring(
                      0,
                      item.regionName.lastIndexOf(item.regionName.substring(40))
                  ) + "..."
                  }}
                </h5>
                <h5 class="text-dark" v-else>{{ item.regionName }}</h5>
                <!-- <div class="dropdown">
              <button
                class="btn p-0"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fa-solid fa-ellipsis"></i>
              </button>
              <ul
                class="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <li>
                  <div
                    class="dropdown-item d-flex align-items-center"
                    data-bs-toggle="modal"
                    data-bs-target="#DeleteUserModal"
                  >
                    Archive
                  </div>
                </li>
              </ul>
            </div> -->
              </div>
              <div class="my-3">
                <h6 class="text-muted">Partner</h6>
                <h4 class="text-dark" v-if="item.clientName.length > 40">
                  {{
                    item.clientName.substring(
                      0,
                      item.clientName.lastIndexOf(item.clientName.substring(40))
                  ) + "..."
                  }}
                </h4>
                <h4 class="text-dark" v-else>{{ item.clientName }}</h4>
              </div>

              <div class="Partner_management_top-kj">

                <div class="Partner_management_contant-2-kj">
                  <div class="mb-3">
                    <span class="text-dark"> Tokens Remaining</span>
                  </div>
                  <h6>{{ item.allocatedToken === 0 ? 'NA' : item.remainingToken }}</h6>
                </div>
                <div class="Partner_management_contant-kj">
                  <div class="mb-3">
                    <span class="text-dark"> Tokens Allocated</span>
                  </div>
                  <h6>{{ item.allocatedToken === 0 ? 'NA' : item.allocatedToken }}</h6>
                </div>
              </div>
            </div>
            <!-- </router-link> -->


            <div class="card-footer card-footer-bg-kj" data-bs-toggle="modal" data-bs-target="#AllocateTokens" @click="
              getCompanyData(
                item.regionName,
                item.remainingToken,
                item.regionId
              )
              " v-if="superadmin() && item.requestCount == 0">
              Allocate Tokens
            </div>
            <div class="card-footer card-footer-bg-kj" data-bs-toggle="modal" type="button"
              data-bs-target="#RequestedTokenModal" v-else-if="superadmin() && item.requestCount > 0" @click="
                ViewReqList(item.regionName, item.remainingToken, item.regionId)
                ">
              View {{ item.requestCount }} Request
            </div>

            <!-- Undo afer live start-->
            <!-- <div class="card-footer card-footer-bg-kj" data-bs-toggle="modal" data-bs-target="#AllocateTokens" @click="
        getCompanyData(
          item.regionName,
          item.remainingToken,
          item.regionId
        )
        " v-if="(superadmin() || this.isApprover) && item.requestCount == 0">
              Allocate Tokens
            </div>
            <div class="card-footer card-footer-bg-kj" data-bs-toggle="modal" type="button"
              data-bs-target="#RequestedTokenModal"
              v-else-if="(superadmin() || this.isApprover) && item.requestCount > 0" @click="
        ViewReqList(item.regionName, item.remainingToken, item.regionId)
        ">
              View {{ item.requestCount }} Request
            </div>
            <div class="card-footer card-footer-bg-kj" @click="openRequestToken(item.regionId)"
              v-else-if="!this.isApprover && !this.isPOClient">
              Request Tokens
            </div> -->
            <!-- Undo afer live start-->

            <!-- <div
              class="card-footer card-footer-bg-kj"
              @click="openRequestToken(item.regionId)"
              v-if="!superadmin()"
            >
              Request Token
            </div> -->
          </div>
        </div>
      </div>
      <paginate v-model="currentPage" :page-count="Page_count" :margin-pages="1" :page-range="1"
        :click-handler="clickCallback" :prev-text="'< Prev'" :next-text="'Next >'" :container-class="'pagination'"
        :page-class="'page-item'" v-if="groupData != 0">
      </paginate>
    </section>

    <!-- Requests Token Modal Popup -->
    <div class="modal fade CreatePartnerModal_hp RequestTokenModal_secction" id="RequestedTokenModal" tabindex="-1"
      aria-labelledby="RequestedTokenModal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title text-centerm-auto" id="RequestedTokenModal">
              Allocate Tokens to {{ modalData.company }}
            </h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="btn-close" id="closerequest"
              @click="clearbtn()"></button>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-between align-items-center">
              <h5>{{ reqList?.length }}-Pending Requests</h5>

              <p class="request-color-muted font-size-12" :class="{ error: this.redtext }">
                Balance Tokens:{{
                  this.regionAllocationList.remainingToken - this.remainingToken
                }}
              </p>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-3 RequestTokenModal_item_box"
              v-for="(item, index) in reqList" :key="item">
              <div class="RequestTokenModal_item_box_company">
                <img src="../../public/dashboard-assets/images/M2/UsersDP2.png" alt="" />
                <div>
                  <h5>{{ item.firstName }}&nbsp;{{ item.lastName }}</h5>
                  <p class="request-color-token">
                    Requested {{ item.tokenAmount }} Tokens
                  </p>

                  <p class="request-color-token-date">
                    {{ dateConvert(item.requestedDate) }}&nbsp;{{
                      timeConverter(item.requestedDate)
                    }}
                  </p>
                </div>
              </div>
              <!-----<div class="RequestTokenModal_item_box_button">--->
              <div class="d-flex">
                <button class="modail_submit_button RequestTokenModal_item_box_CheckButton px-5 py-1 mx-1" id="right"
                  :hidden="!this.approvedReq.includes(item.requestId)">
                  <i class="fa-solid fa-check"></i>
                </button>
                <button class="modail_submit_button px-3 py-1 mx-1 text-muted float-start border-secondary"
                  data-bs-toggle="modal" data-bs-target="#RejectTokenModal" id="remove"
                  :hidden="this.approvedReq.includes(item.requestId)" @click="
                    rejectBtn(
                      item.firstName,
                      item.lastName,
                      item.tokenAmount,
                      item.id,
                      item.regionId
                    )
                    ">
                  Reject
                </button>
                <button class="modail_submit_button px-3 py-1 mx-1" id="aprove" @click="
                  approverequest(
                    item.requestId,
                    'Approved',
                    index,
                    item.tokenAmount,
                    item.regionId
                  )
                  " :hidden="this.approvedReq.includes(item.requestId)" :disabled="this.regionAllocationList.remainingToken < item.tokenAmount
          ">
                  Approve
                </button>
              </div>
            </div>

            <!--<div
              class="RequestTokens_Button mt-4 mb-3 d-flex align-items-center"
            >
              <button
                class="btn me-2"
                data-bs-toggle="modal"
                data-bs-target="#RequestTokenModal"
                @click="openTokenModal(2)"
              >
                <i class="fa-solid fa-plus"></i>
              </button>
              Request Tokens
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- RejectTokenModal -->
    <div class="modal fade" id="RejectTokenModal" tabindex="-1" aria-labelledby="RejectTokenModalLabel"
      aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-body p-4">
            <div class="">
              <h3 class="mb-3">Reject Tokens?</h3>
              <p class="text-muted">
                Are you sure you want to reject
                <strong class="text-dark"> {{ this.amt }}</strong> tokens
                requested from {{ this.firstname }}&nbsp;{{ this.lastname }}.
              </p>
            </div>
            <div class="Deactivate_buttons row mt-3 justify-content-center">
              <button class="col-5 Deactivate_Cancel_buttons" data-bs-dismiss="modal" aria-label="btn-close"
                id="rejectcancel" @click="closeModal()">
                Cancel
              </button>
              <button type="button" class="col-5 btn Deactivate_Deactivate_buttons"
                @click="rejectToken(this.reqId, 'Rejected', this.amt)">
                Reject
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- model Request Token -->
    <div class="modal fade" id="RequestTokenModal" tabindex="-1" aria-labelledby="IncreaseTokenModalLabel"
      aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable model-sm">
        <div class="modal-content border-radius-kj-20">
          <div class="modal-header token-model-header-color">
            <h5 class="modal-title text-centerm-auto" id="IncreaseTokenModalLabel">
              Request Tokens
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="btn-close"
              @click="clearAmountButton('RequestTokenModal')"></button>
          </div>
          <div class="modal-body">
            <h5 class="my-4">How many tokens do you need?</h5>
            <form class="row my-3" method="">
              <div class="tokenPrice token-model-kj d-flex">
                <div class="value-button-min" id="decrease" @click="requestedTokenDecreaseValue()"
                  value="Decrease Value" :class="{ active_inc_dec_button: requestdecreasevalue() }"
                  disabled="requestdecreasevalue()">
                  <i class="fa-solid fa-minus"></i>
                </div>
                <input type="number" class="w-75 input-number-token-kj" id="number" placeholder="0"
                  v-model="requestedAmount" :class="{
                    input_error_border:
                      requestedAmount > 5000 && this.clientId != 1001,
                  }" oninput="validity.valid||(value='');" />
                <div class="value-button-max" id="increase" @click="requestedTokenIncreaseValue()"
                  value="Increase Value" :class="{
                    active_inc_dec_button:
                      this.requestedAmount > 5000 && this.clientId != 1001,
                  }">
                  <i class="fa-solid fa-plus"></i>
                </div>
              </div>
              <p v-if="this.requestedAmount > 5000 && this.clientId != 1001" style="color: red">
                You cannot Request more than 5000 tokens.
              </p>
              <h5 class="my-3">
                Balance Tokens: {{ regionAllocationList.remainingToken }}
              </h5>
              <div class="text-end mt-2">
                <button type="button" class="btn btn-token-color-kj" :disabled="!requestedButtonDisable()" :class="{
                  actived_form_button:
                    (requestedAmount > 0 && requestedAmount < 5001) ||
                    (requestedAmount >= 5001 && this.clientId == 1001),
                }" @click="postRequestedAmount">
                  Request
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- AllocateTokens -->
    <div class="modal fade" id="AllocateTokens" tabindex="-1" aria-labelledby="IncreaseTokenModalLabel"
      aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable model-sm">
        <div class="modal-content border-radius-kj-20">
          <div class="modal-header token-model-header-color">
            <h4 class="modal-title text-centerm-auto" id="IncreaseTokenModalLabel">
              Allocate Tokens
            </h4>
            <button type="button" class="btn-close" id="close" data-bs-dismiss="modal" aria-label="btn-close"
              @click="clearAmountButton('AllocateTokens')"></button>
          </div>
          <div class="modal-body">
            <h5 class="my-4 request-color-token">
              How many tokens do you want to allocate to
              <strong class="text-dark">{{ regionName }}? </strong>
            </h5>
            <form class="row my-3" method="">
              <div class="tokenPrice token-model-kj d-flex">
                <div class="value-button-min" id="decrease" @click="allocatedTokenDecreaseValue()"
                  value="Decrease Value" disabled="allocatedecreasevalue()"
                  :class="{ active_inc_dec_button: allocatedecreasevalue() }">
                  <i class="fa-solid fa-minus"></i>
                </div>
                <input type="number" class="w-75 input-number-token-kj" id="number" placeholder="0"
                  v-model="allocatedAmount" oninput="validity.valid||(value='');" />
                <div class="value-button-max" id="increase" @click="allocatedTokenIncreaseValue()"
                  value="Increase Value">
                  <i class="fa-solid fa-plus"></i>
                </div>
              </div>
              <h5 class="my-3 request-color-token">
                Balance Tokens: {{ remainingToken }}
              </h5>
              <div class="text-end mt-2">
                <button type="button" class="btn btn-token-color-kj" :disabled="!allocatedButtonDisable()"
                  :class="{ active_form_button: this.allocatedAmount > 0 }" @click="postAmountAllocation">
                  Allocate
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Archive Test -->
    <div class="modal fade" id="DeleteUserModal" tabindex="-1" aria-labelledby="DeleteUserModalLabel"
      aria-hidden="true">
      <!-- <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-body p-4">
        <div class="">
          <h3 class="mb-3">Archive Region?</h3>
          <p class="text-muted">
            Are you sure you want to archive
            <strong class="text-dark">Texas HR Dept. </strong>
          </p>
        </div>
        <div class="Deactivate_buttons row mt-5 justify-content-center">
          <button
            class="col-5 Deactivate_Cancel_buttons"
            data-bs-dismiss="modal"
            aria-label="btn-close"
          >
            Cancel
          </button>
          <button
            type="button"
            class="col-5 btn Deactivate_Deactivate_buttons"
          >
            Archive
          </button>
        </div>
      </div>
    </div>
  </div> -->
    </div>
  </div>

  <!-- </div> -->
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
import { superadmin } from "../utils/helper";
import { getUserPermissionData } from "../utils/helper";
import Paginate from "vuejs-paginate-next";
import { SetClarityData } from "../platformFeatures/featureUtils";
export default {
  name: "TokenmanagementViewRegion",
  components: {
    paginate: Paginate,
  },
  data() {
    return {
      groupData: [],
      show: false,
      viewdataTotalcount: 0,
      page: 1,
      limit: 8,
      search: "",
      // partners: "",
      Page_count: 1,
      tokenList: [],
      offset: 5,
      viewData: [],
      regionName: "",
      remainingToken: 0,
      allocatedAmount: null,
      regionId: "",
      requestedAmount: null,
      regionAllocationList: [],
      searchDisable: false,
      //filter
      applyfilter: 0,
      searchfilter: "",
      filters: {
        partners: [],
        company: "",
      },
      input: "",
      result: [],
      comapny: [],
      currentPage: 1,
      // filterTab:1,
      // filterTestData:[],
      filterPartnerData: [],

      redtext: "",
      reqList: [],
      modalData: "",
      ReqTestId: "",
      isActive: true,
      approvedReq: [],
      firstname: "",
      lastname: "",
      amt: "",
      clientid: "",
      reqId: "",
      isApprover: false,
      isPOClient: false
    };
  },
  async created() {
    this.isPOClient = this.user.invoiceType == "PayOrder";
    if (this.isPOClient) {
      this.isApprover = false;
    } else {
      var approvers = await this.GetApprovers("Tokens");
      if (approvers.status) {
        var approverUser = approvers.object.data.users.find(obj => obj.userId);
        if (approverUser.userId == this.user.userId) {
          this.isApprover = true;
        }
      }
    }
  },
  async mounted() {
    SetClarityData();
    await this.getgroupList();

    await this.getRegionAllocation();
    //  this.filterTestData=this.groupData;
    this.filterPartnerData = this.groupData;
  },
  computed: {
    ...mapState({
      authenticated: (state) => state.auth.authenticate,
      user: (state) => state.auth.user,
      clientId: (state) => state.auth.user.clientId,
      // regionId: (state) => state.auth.user.regionId,
      // PartnerId: (state) => state.auth.user.PartnerId,
    }),
  },
  methods: {
    ...mapActions([
      "viewGroupsList",
      "GetTokenAllocation",
      "viewtestList",
      "regionAllocatedToken",
      "GetTAllocation",
      "requestedToken",
      "requestedTokens",
      "rejectReq",
      "regionRequestedToken",
      "regionRequest",
      "regionRejectRequest",
      "GetApprovers"
    ]),
    superadmin,
    getUserPermissionData,
    ...mapMutations(["setLoading"]),
    dateConvert: (value) => {
      return moment(String(value)).format("DD MMM YYYY");
    },
    async getApproverList() {
      const user = await this.GetAllUsers({
        clientId: this.user.clientId,
        page: 1,
        limit: 100,
        status: 4,
      });

      this.users = user.object.data.users.map((i) => ({
        value: i.id,
        label: i.name,
      }));

      var approvers = await this.GetApprovers("Tokens");
      if (approvers.status && approvers.object.data.type == "Tokens") {

        this.selecteduser = approvers.object.data.users.map((i) => ({
          value: i.userId,
          label: i.firstName + " " + i.lastName,
        }));
        // console.log(this.users)
        // console.log(this.selecteduser)
      }

    },

    async ViewReqList(companyName, balanceToken, id) {
      this.modalData = {
        company: companyName,
        remainingToken: balanceToken,
        clientId: id,
      };
      var request = await this.regionRequest({
        regionId: id,
      });
      // var request = await this.requestedTokens({
      //   clientId: id,
      // });
      if (request != undefined) {
        this.reqList = request.object.data;
        this.checkBalance();
        this.reqList.forEach((element) => {
          if (element.tokenAmount > this.regionAllocationList.remainingToken) {
            this.redtext = true;
          } else {
            this.redtext = false;
          }
        });
      }
    },
    //time-converter
    timeConverter(val) {
      const today = new Date(val);
      let h = today.getHours();
      let m = today.getMinutes();
      var meridian = h >= 12 ? "PM" : "AM";
      h = h % 12;
      h = h ? h : 12;
      m = m < 10 ? "0" + m : m;
      var strTime = h + ":" + m + " " + meridian;
      return strTime;
    },
    async approverequest(reqId, status, index, tokenamount, id) {
      var rejectrequest = await this.regionRejectRequest({
        regionId: id,
        requestId: reqId,
        status: status,
        tokenAmount: tokenamount,
        company: this.modalData.company,
      })
      // var rejectrequest = await this.rejectReq({
      //   clientId: id,
      //   requestId: reqId,
      //   status: status,
      //   tokenAmount: tokenamount,
      //   company: this.modalData.company,
      // });
      this.isActive = false;
      if (rejectrequest.status) {
        this.approvedReq.push(reqId);

        setTimeout(async () => {
          var request = await this.regionRequest({
            regionId: id,
          });
          // var request = await this.requestedTokens({
          //   clientId: id,
          // });
          this.reqList = request.object.data;
          if (this.reqList.length == 0) {
            document.getElementById("closerequest").click();
          } else {
            this.reqList.forEach((element) => {
              if (
                element.tokenAmount > this.regionAllocationList.remainingToken
              ) {
                this.redtext = true;
              } else {
                this.redtext = false;
              }
            });
          }
        }, 3000);
      } else {
        this.regionAllocationList.remainingToken =
          this.regionAllocationList.remainingToken - tokenamount;
      }

      this.remainingToken = this.reqList[index].tokenAmount;
      await this.getgroupList();
      await this.getRegionAllocation();
      document.getElementById("closerequest").click();
    },

    async f(firstName, lastName, amt, reqid, clientId) {
      (this.firstname = firstName),
        (this.lastname = lastName),
        (this.amt = amt),
        (this.reqId = reqid),
        (this.clientid = clientId);
    },
    async rejectToken(reqId, status, tokenamount) {
      await this.regionRejectRequest({
        regionId: this.clientid,
        requestId: reqId,
        status: status,
        tokenAmount: tokenamount,
        company: this.modalData.company,
      });
      document.getElementById('rejectcancel').click();
      this.closeModal();
      await this.getgroupList();

    },
    closeModal() {
      document.getElementById('closerequest').click();
    },
    checkBalance(amt) {
      Array.prototype.sum = function (prop) {
        var total = 0;
        for (var i = 0, len = this.length; i < len; i++) {
          total += this[i][prop];
        }
        return total;
      };
      var total = this.reqList.sum("tokenAmount");
      if (total > amt) return true;
      else return false;
    },

    openRequestToken(id) {
      window.$("#RequestTokenModal").modal("show");
      this.ReqTestId = id;
    },

    // Searching box
    opensearch() {
      document.querySelector(".Searching_input-box").classList.add("open");
    },
    async closesearch() {
      document.querySelector(".Searching_input-box").classList.remove("open");
      this.result = [];
      this.input = "";
      this.filters.company = "";
      this.currentPage = 1;
      this.page = 1;
      await this.getgroupList();
    },
    async closemobilesearch() {
      this.show = false;
      document.querySelector(".Searching_input_box_mobile_view").classList.remove("open");
      this.result = [];
      this.filters.company = "";
      this.input = "";
      this.currentPage = 1;
      this.page = 1;
      await this.getgroupList();
    },
    openmobilesearch() {

      this.result = [];
      this.input = "";
      this.show = true;
      document.querySelector(".Searching_input_box_mobile_view").classList.add("open");
    },

    async filteredList() {
      this.input = this.input.trim();
      if (this.input != "") {
        // this.company = [];
        // this.result = [];
        // var list = await this.viewGroupsList({
        //   clientId: this.clientId,
        //   page: 1,
        //   limit: 8,
        //   search: this.input,
        // });
        // var x = list.object.data.items;
        // this.groupData = x
        // this.viewdataTotalcount = list.object.data.totalItems
        // this.Page_count = list.object.data.totalPages;
        this.currentPage = 1;
        this.page = 1;
        this.filters.company = this.input;
        await this.getgroupList();
      } else {
        this.result = [];
        this.groupData = this.filterPartnerData;
        this.filters.company = "";
        await this.getgroupList();
      }
    },
    async getgroupList() {
      this.searchDisable = true;

      var listData = await this.viewGroupsList({
        clientId: this.clientId,
        page: this.page,
        limit: this.limit,
        search: this.filters.company,
        partners: this.filters.partners.toString(),
      });
      this.searchDisable = false;
      var ar = [];
      if (listData != undefined) {
        this.groupData = listData.object.data.items;
        this.groupData.forEach((element) => {
          ar.push(element.clientId);
        });
        if (this.clientId == 1001 || this.isApprover) {
          this.groupData.forEach(async (element) => {
            // var request = await this.requestedTokens({
            //   clientId: element.clientId,
            // });
            var request = await this.regionRequest({
              regionId: element.regionId,
            });
            if (request.status == false) {
              element.requestCount = 0;
            } else {
              element.requestCount = await request.object.data.length;
            }
          });
        }

        this.viewdataTotalcount = listData.object.data.totalItems;
        this.Page_count = listData.object.data.totalPages;
      }
      if (this.input.trim() != "") {
        listData.Search = this.input;

      }
    },
    stringTOHtml(item, idx) {
      setTimeout(() => {
        if (this.input != "") {
          let re = new RegExp(this.input.toLowerCase(), "g");
          var html = document.getElementById(idx);
          var ex = item
            .toLowerCase()
            .replace(
              re,
              `<span style="color: #7b68ee !important">${this.input}</span>`
            );
          if (html) html.innerHTML = ex;
        }
      }, 100);
    },

    async searchregionname(val) {
      this.input = val.trim();
      this.page = 1;
      this.filters.company = val;
      this.result = [];
      this.currentPage = 1;
      await this.getgroupList();
    },
    //*********search end*********

    filterDisabledButton() {
      if (this.applyfilter > 0) {
        return true;
      } else {
        return false;
      }
    },

    requestdecreasevalue() {
      if (
        this.requestedAmount == null ||
        this.requestedAmount == 0 ||
        this.requestedAmount == "" ||
        this.requestedAmount < 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    allocatedecreasevalue() {
      if (
        this.allocatedAmount == null ||
        this.allocatedAmount == 0 ||
        this.allocatedAmount == "" ||
        this.allocatedAmount < 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    requestedButtonDisable() {
      if (this.requestedAmount > 0 && this.clientId == 1001) {
        return true;
      } else {
        if (this.requestedAmount > 0 && this.requestedAmount < 5001) {
          return true;
        } else if (this.requestedAmount > 5000) {
          return false;
        }
      }
    },
    allocatedButtonDisable() {
      return this.allocatedAmount > 0;
    },

    clearAmountButton(modalID) {
      if (modalID == "RequestTokenModal") {
        this.requestedAmount = 0;
      } else {
        this.allocatedAmount = 0;
      }
    },

    clickCallback(pageNum) {
      this.page = pageNum;
      this.getgroupList();
    },

    // async filterData() {
    //   var listData = await this.viewGroupsList({
    //     clientId: this.clientId,
    //     page: this.page,
    //     limit: 300,
    //   });
    //   if (listData != undefined) {
    //     this.filterPartnerData = listData.object.data.items;
    //   }
    // },

    async getRegionAllocation() {
      var list = await this.GetTAllocation({
        clientId: this.clientId,
      });
      if (list != undefined) {
        this.regionAllocationList = list.object.data;
      }
    },
    async getCompanyData(regionName, remainingToken, regionid) {
      (this.regionName = regionName), (this.remainingToken = remainingToken);
      this.regionId = regionid;
    },

    async allocatedTokenIncreaseValue() {
      this.allocatedAmount = this.allocatedAmount + 1;
    },

    async allocatedTokenDecreaseValue() {
      if (
        this.allocatedAmount == null ||
        this.allocatedAmount == 0 ||
        this.allocatedAmount == "" ||
        this.allocatedAmount < 0
      ) {
        this.allocatedAmount = null;
      } else {
        this.allocatedAmount = this.allocatedAmount - 1;
      }
    },

    async requestedTokenIncreaseValue() {
      if (this.requestedAmount < 5000) {
        this.requestedAmount = this.requestedAmount + 1;
      }
    },

    async requestedTokenDecreaseValue() {
      if (
        this.requestedAmount == null ||
        this.requestedAmount == 0 ||
        this.requestedAmount == "" ||
        this.requestedAmount < 0
      ) {
        this.requestedAmount = null;
      } else {
        this.requestedAmount = this.requestedAmount - 1;
      }
    },

    async postAmountAllocation() {
      await this.regionAllocatedToken({
        regionId: this.regionId,
        amount: this.allocatedAmount,
        regionName: this.regionName,
      });
      document.getElementById("close").click();
      window.$("#AllocateTokens").modal("hide");
      this.allocatedAmount = null;
      this.getgroupList();
      // this.postAmountAllocation();
    },

    async postRequestedAmount() {
      await this.regionRequestedToken({
        regionId: this.ReqTestId,
        amount: this.requestedAmount,
      });
      window.$("#RequestTokenModal").modal("hide");
      this.requestedAmount = null;
      this.getRegionAllocation();
    },
    //filter

    async addFilter(value, e) {
      if (e.target.checked) {
        this.filters.partners.push(value);
      } else {
        this.filters.partners.splice(
          Object.freeze(
            JSON.parse(JSON.stringify(this.filters.partners))
          ).indexOf(value),
          1
        );

        if (this.filters.partners.length == 0) {
          await this.getgroupList();
          await this.getRegionAllocation();
        }
        //  this.filterTestData=this.groupData;
        // this.filterPartnerData = this.groupData;
      }
      this.applyfilter = this.filters.partners.length;
    },
    async clearFilters() {
      // this.filters.Test = [];
      this.filters.partners = [];
      this.applyfilter = 0;
      this.searchfilter = "";
      await this.getgroupList();
      document.getElementById("filterDropDown").click();
    },
    async applyFilters() {
      this.page = 1;
      this.currentPage = 1;
      await this.getgroupList();
      document.getElementById("filterDropDown").click();
      // this.filters.partners=[];
    },
    crossfilter() {
      document.getElementById("filterDropDown").click();
    },
    async Filterresult() {
      if (this.searchfilter != "") {
        // if(this.filterTab==1){
        //   this.filterTestData=this.groupData.filter(
        //     (element)=>
        //     element.regionName.toLowerCase()
        //     .includes(this.searchfilter.toLowerCase())
        //   );
        // }else{
        this.filterPartnerData = this.groupData.filter((element) =>
          element.clientName
            .toLowerCase()
            .includes(this.searchfilter.toLowerCase())
        );
        // }
      } else {
        // this.filterTestData=this.groupData;
        this.filterPartnerData = this.groupData;
      }
    },
    filterclose() {
      document.getElementById("filterDropDown").click();
    },
  },
};

</script>
<style scoped>
.active_form_button {
  background-color: #7b68ee !important;
  color: #fff !important;
}

.active_inc_dec_button {
  background-color: #e8e4ff !important;
  color: gray !important;
}

.input_error_border:focus-visible {
  border: 2px solid red !important;
  outline: none !important;
}

.input_error_border:focus {
  border: 1px solid red !important;
}

.page-item.disabled .page-link {
  background-color: #fff !important;
  border-color: #fff !important;
}

.pagination .page-item .page-link {
  width: 30px;
  height: 32px;
  background: transparent;
  display: flex;
  border-radius: 100px;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  margin: 5px;
  color: #000 !important;
  border: none;
  cursor: pointer;
}

.pagination {
  justify-content: flex-end;
}

.pagination .page-item.active .page-link {
  font-weight: 600;
  background: #ffc801;
}

.pagination .page-item:last-child .page-link {
  background-color: transparent;
  border: none;
  width: 100% !important;
}

.pagination .page-item:first-child .page-link {
  background-color: transparent;
  border: none;
  width: 100% !important;
}

.pagination .page-item.disabled .page-link {
  color: rgb(130, 130, 130) !important;
  cursor: no-drop !important;
}


input[type=number] {
  -moz-appearance: textfield;
}
</style>
